module.exports = __webpack_public_path__ + "static/extra_4-329ecd4d23863ded1891a8452fa60f80.jpg";